import {
  PDP_APP_BANNER,
  PDP_APP_BANNER_IT,
  REBRANDING_COM_TOGGLE,
} from 'shared/experiments/consts/names'
import { EXPERIMENT_VARIATION } from 'shared/experiments/consts/variants'
import type { Experiment } from 'types/shopConfig'

export const appsFlyerExperimentCom: Experiment = {
  name: PDP_APP_BANNER,
  isEnabled: true,
  variables: { f: 1 },
  variant: EXPERIMENT_VARIATION.VARIATION_1,
}

export const appsFlyerExperimentIt: Experiment = {
  name: PDP_APP_BANNER_IT,
  isEnabled: true,
  variables: { f: 1 },
  variant: EXPERIMENT_VARIATION.VARIATION_1,
}

export const rebrandingComExperiment: Experiment = {
  name: REBRANDING_COM_TOGGLE,
  isEnabled: true,
  variables: { f: 1 },
  variant: EXPERIMENT_VARIATION.V1,
}
